export default __webpack_public_path__ + "media/color/ppp-6adbc0ea.svg";